var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Link } from 'react-router';
import { isRelativeUrl, isFlipkartUrl } from 'utils/urlutils';
export default function LinkMaybe(props) {
    const { to, preventAnchorLink } = props, rest = __rest(props, ["to", "preventAnchorLink"]);
    if (to && !preventAnchorLink) {
        if (isRelativeUrl(to) || isFlipkartUrl(to)) {
            return <Link to={to} {...rest}/>;
        }
        else {
            return <a href={to} {...rest}/>;
        }
    }
    return <div {...rest}/>;
}
